<template>
  <div id="app">
    <div class="row component-container">
    <div class="map col-md-12">
      <MglMap :accessToken="accessToken" :mapStyle="mapStyle">
        <MglNavigationControl position="top-right" :showCompass="false" />
        <MglScaleControl />
        <MglGeojsonLayer v-for="(source,index) in geoSource.data.features" :key="index"
                         :sourceId="'source'+index"
                         :source="{type:'geojson',data:source}"
                         :layerId="source.properties.NAME"
                         :layer="layer"
                         @click="clickLayer"
                         @mouseover="hoverLayerTest"
                         @mouseleave="resetHover"
        />
      </MglMap>
      <CityModal :state="selectedKey" :cities="selectedResults" :modalActive="modalOpen" v-if="modalOpen" @closeModal="closeModal"></CityModal>
    </div>

    </div>
  </div>
</template>

<script>
//@TODO - Update parameters of "modalOpen" to not consider array length == 0, as that prevents the "no results" message from being visible
import axios from 'axios'
//import { RadioSvgMap  } from "vue-svg-map";
import USA from "@svg-maps/usa";
import Mapbox from "mapbox-gl"
import { MglMap, MglGeojsonLayer, MglNavigationControl, MglScaleControl } from "vue-mapbox";
import { getLocationName, getSelectedLocationName } from '/src/utilities/index.js'
import geoBoundaryData from '/public/maps/gz_2010_us_040_00_500k.json'
import CityModal from '/src/components/CityModal.vue';
export default {
  name: 'FranchiseLocationsMap',
  components: {
    //RadioSvgMap
    MglMap,
    MglGeojsonLayer,
    CityModal,
    MglScaleControl,
    MglNavigationControl
  },
  //@TODO - If CB wants multiple versions of this tool, we should attempt to create a single map component without opinionated wrappers / styling / form / etc.
  data: () => {
    return {
      source: {
        id: 'states',
        type: 'vector',
        url: 'mapbox://mapbox.boundaries-adm1-v3'
      },
      geoSource: {
        type: 'geojson',
        data: geoBoundaryData
      },
      layer: {
        type: 'fill',
        paint: {
          'fill-color': '#CCCCCC',
          'fill-opacity': [
            'case',
            ['boolean', ['feature-state', 'hover'], false],
            1,
            0.5
          ],
          'fill-outline-color':'#000'
        }
      },
      activeLayer: {
        type: 'fill',
        paint: {
          'fill-color': '#000000',
          'fill-opacity': 0.5,
          'fill-outline-color':'#000'
        }
      },
      selectedKey: '',
      selectedResults: [],
      selectedLayer: null,
      selectedMap: null,
      layers: [],
      accessToken: 'pk.eyJ1IjoidGludHdvcmxkIiwiYSI6ImNsM2MwbDI4cDAzbHMzYnBhdjJib3M4NXIifQ.F8mRX_X4bP1NflrpUUZYGQ',
      mapStyle: 'mapbox://styles/tintworld/cl3c0t777001j15qpnkukn4g1',
      panZoom: null,
      center: { lat: 26.40, lng: -80.08 },
      map_zoom: 2,
      availableLocations: [],
      infoWindowPos: null,
      infoWindowOpen: false,
      currentMarkerIndex: null,
      US: USA,
      infoOptions: {
        content: '',
        pixelOffset: {
          width:0,
          height: -35
        }
      },
      lastClickedLayer: null,
      hoverLayerId: null,
      popupVisible: false,
      pointedLocation: null,
      selectedLocation: null,
      user: {
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        netWorth:null,
        liquidCapital:null
      },
      netWorthOptions: [
          '$150,000 - $249,000','$250,000 - $349,000','$350,000 - $449,000','$450,000 - $549,000','$550,000 - $1,000,000','> $1,000,000'
      ],
      liquidCapitalOptions: [
          '$100,000 - $199,000','$200,000 - $299,000','$300,000 - $499,000','$500,000 - $1,000,000','> $1,000,000'
      ]
    }
  },
  created(){
    const vm = this;
    vm.mapbox = Mapbox;
    vm.getData();
  },
  computed: {
    modalOpen(){
      if(this.selectedResults !== undefined && this.selectedResults.length > 0 && this.popupVisible){
        return true;
      }
      return false;
    }
  },
  methods: {
    closeModal(){
      this.popupVisible = false;
    },
    getData(){
      const vm = this;
      axios.get('https://sync.tintworld.com/prospective-locations')
      .then(function(response){
        var data = response.data;
        vm.availableLocations = data;
      })
    },
    clickLayer: function(e){
      if(this.lastClickedLayer !== null){
        e.map.setPaintProperty(this.lastClickedLayer,'fill-color','#CCCCCC');
      }
      this.lastClickedLayer = e.layerId;
      var results = this.availableLocations[e.layerId];
      this.selectedKey = e.layerId;
      e.map.setPaintProperty(e.layerId,'fill-color','#ffe300');
      this.selectedResults = results;
      this.popupVisible = true;
      e.map.flyTo({center:e.mapboxEvent.lngLat,zoom:5});
    },
    userSelection(){
      this.panZoom.smoothZoom(0, 0, 0.5);
    },
    resetHover(e){
      if(e.layerId !== this.lastClickedLayer){
        this.hoverLayerId = null;
        e.map.setPaintProperty(e.layerId,'fill-color','#CCCCCC');
      }
    },
    hoverLayerTest(e){
      if(e.layerId){
        this.hoverLayerId = e.layerId;
      }
      if(e.layerId !== this.lastClickedLayer){
        e.map.setPaintProperty(e.layerId,'fill-color','#666666');
      }

      /*

      this.selectedKey = e.layerId;
      this.selectedLayer = e.component;
      this.selectedMap = e.map;
      e.component.layer = this.activeLayer;
       */
      //e.map.
    },
    pointLocation(event) {
      //@TODO - Need to Zoom in on the Path, Load Info Window with Checkboxes
      //@TODO - Need to highlight / color change the selected state
      this.pointedLocation = getLocationName(event.target);

    },
    getSelectedLocationName
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 25px;
}

.tw-franchise-info-modal{
  font-size: 16px;
  font-weight: bold;
}
.info-area .input-group-text {
  min-width:150px;
}
.component-container {
  border: solid 1px black;
  border-radius: 10px;
}
.component-container .map {
  margin: 0;
  padding: 0;
  border-radius: 10px;
  overflow: hidden;
  min-height:500px;
}
.component-container .info-area {
  padding-top: 15px;
  padding-bottom: 15px;
}
.franchise-location-results {
  position: absolute;
  max-width: 500px;
  bottom: 0;
  right: 0;
  z-index: 9999999999;
  background: RGBA(255,255,255,.8);
  min-width: 300px;
  min-height: 300px;
  border: solid 1px black;
  margin: 15px;
  display: none;
  padding: 15px;
  max-height: 90%;
  overflow: auto;
}
.franchise-location-results.active {
  display:block;
}
#location-options .close {
  color: white !important;
  font-size: 28px;
  font-weight: 300;
  opacity: 1;
}
.modal-header, .modal-footer {
  background-color: black;
  color: #ffe300;
}
</style>
